/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { MAX_REMINDER_TIMES, REMINDER_TIME_REGEX } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getNotificationPreferencesV1ResponseDataSchema = z.object({
  notificationEnabled: z.boolean(),
  reminderTimes: z.array(z.string().regex(REMINDER_TIME_REGEX)).max(MAX_REMINDER_TIMES),
  remainingSlots: z.number().int().min(0).max(MAX_REMINDER_TIMES),
  timezone: z.string().nullable(),
});

export type IGetNotificationPreferencesV1ResponseData = z.infer<
  typeof getNotificationPreferencesV1ResponseDataSchema
>;

export const getNotificationPreferencesV1ResponseSchema = createApiResponseSchema(
  getNotificationPreferencesV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetNotificationPreferencesV1ResponseData>>;

export type IGetNotificationPreferencesV1Response = IAPI<IGetNotificationPreferencesV1ResponseData>;
